export {
  PRESET_PROPERTY_CATEGORY,
  CORE_VERSION,
  CoreWidgetName,
} from '@sunmao-ui/shared';

export const ComponentFormElementId = 'sunmao-component-form';

export { PREVENT_POPOVER_WIDGET_CLOSE_CLASS } from './widget';
